import ActionsPerformanceDataExplorerFilterField from "./ActionsPerformanceDataExplorerFilterField";

const ActionsPerformanceDataExplorerFieldsQuery = ({
  fields,
  onRemoveField,
}) => {
  const filterToggleFields = fields.filter((field) => field.toggle);

  return (
    <>
      {filterToggleFields.map((field) => (
        <ActionsPerformanceDataExplorerFilterField
          key={field.value}
          field={field}
          onFieldClick={onRemoveField}
        />
      ))}
    </>
  );
};

export default ActionsPerformanceDataExplorerFieldsQuery;
